import { useContext, useEffect, useCallback } from "react";
import { BlocksValue } from "../contexts/blocks";
import useParentSources from "./useparentsources";
import { SourcesValue } from "../contexts/sources";
import { ErrorsDisbatch } from "../contexts/errors";

export default function useElementErrors({ block, path, disabled }) {
  const blocks = useContext(BlocksValue);
  const sources = useContext(SourcesValue);
  const pathSources = useParentSources(path);
  const disbatch = useContext(ErrorsDisbatch);

  const checkWithSources = useCallback(
    (dynamicObject) => {
      if (!dynamicObject[0]) {
        return true;
      }
      const validSource = [...sources, ...pathSources].find(
        (x) => !!x && x.code === dynamicObject[0].value
      );

      return !!validSource;
    },
    [sources, pathSources]
  );

  const checkProps = useCallback(
    (block, schema) => {
      const errors = [];
      schema.props.forEach((prop) => {
        const value = block.props[prop.name];
        if (!value && prop.required) {
          errors.push({
            blockId: block.id,
            blockName: block.name,
            blockError: `${prop.displayName} is a required prop`,
          });
        }
        if (Array.isArray(value)) {
          const dynamicValues = value.filter((x) => typeof x !== "string");
          const check = dynamicValues.every((x) => {
            return checkWithSources(x);
          });

          if (!check) {
            errors.push({
              blockId: block.id,
              blockName: block.name,
              blockError: `${prop.displayName} value is not valid`,
            });
          }
        }
      });

      return errors;
    },
    [sources, pathSources, checkWithSources]
  );

  const checkConditions = useCallback(() => {}, [sources, pathSources, blocks]);

  const checkEvents = useCallback(() => {}, [sources, pathSources, blocks]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!block) {
        return;
      }

      if (disabled) {
        return;
      }
      const schema = blocks.find((x) => x.name === block.component);

      if (!schema) {
        //Send Error that element no longer exists on app
        return;
      }

      //Check value of block props to make sure from source
      const propsErrors = checkProps(block, schema);

      //check value of conditions to make sure match sources

      //check value of events to make sure params are from active source

      disbatch({
        type: "setErrorsForBlock",
        value: [...propsErrors],
        blockId: block.id,
      });
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [block, blocks, checkProps]);
}
